import React, {useEffect} from 'react'
import AppContainer from "../../components/container/AppContainer";
import Text from "../../components/text/Text";
import Colors from "../../styles/Colors";
import Section from "../../components/container/Section";
import {TitleContainer} from "../../styles/GlobalStyles"
import styled from "@emotion/styled";
import Bulletin from "../../assets/images/bulletin_communal.jpeg"
import {GAPageView} from "../../services/AnalyticsService";

const News = () => {
    useEffect(() => {
        GAPageView("News")
    }, []);

    return (
        <AppContainer>
            <Section
                marginVertical={50}
                paddingHorizontal={20}
            >
                <TitleContainer>
                    <Text
                        type={"h4"}
                        color={Colors.green}
                    >
                        Il parle de nous
                    </Text>
                </TitleContainer>

                <Image src={Bulletin} alt={"Bulletin municipal"}/>
            </Section>
        </AppContainer>
    )
}

export default News

const Image = styled.img`
  width: 80%;
  height: 80%;
  box-shadow: ${Colors.dropdownShadow};
  border-radius: .2%;
  margin: 20px 2.5%;

  @media (max-width: 768px) {
    width: 100%;
    height: 100%;
    margin: 20px 0;
  }
`
